(function () {
    'use strict';

    angular
        .module('app.designTheme')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates(), "/");
    }

    function getStates() {
        return [
            {
                state: 'designTheme',
                config: {
                    url: '/designTheme',
                    templateUrl: 'app/designTheme/designTheme.html',
                    controller: 'DesignThemeController',
                    controllerAs: 'vm',
                    title: 'Tasarım Şabloları',
                    settings: {
                        //nav: 102,
                        //topName: 'products',
                        //name: 'designTheme',
                        //content: 'Tasarım Şabloları',
                        //breadcrumb: 'Tasarım Şabloları',
                        //breadcrumbIcon: 'format_color_fill'
                    }
                }
            }
        ];
    }
})();